/**
 * Formats file size in bytes to a human-readable string in MB
 * @param bytes - File size in bytes
 * @param decimals - Number of decimal places to show (default: 1)
 * @returns Formatted string like "1.4mb" or null if bytes is falsy
 */
export const formatFileSize = (bytes: number | null | undefined, decimals: number = 1): string | null => {
  if (!bytes || bytes <= 0) {
    return null;
  }

  const mb = bytes / (1024 * 1024);
  return `${mb.toFixed(decimals)}mb`;
};
